export const dataContact = {
    "vendedores": [
      {
        "nombre": "Rodrigo",
        "telefono": "2915717522",
        "salutacion": "¡Hola! 👋"
      },
      {
        "nombre": "Ramiro",
        "telefono": "2915720273",
        "salutacion": "¡Hola! 👋"
      },
      {
        "nombre": "Santiago",
        "telefono": "2914601927",
        "salutacion": "¡Hola! 👋"
      },
      {
        "nombre": "Claudio",
        "telefono": "2915720304",
        "salutacion": "¡Hola! 👋"
      }
    ],
    "contacto_administracion": {
      "nombre": "Administración",
      "telefono": "2915719625",
      "salutacion": "¡Hola! 👋"
    },
    "contacto_deposito": {
      "nombre": "Depósito",
      "telefono": "2915719121",
      "salutacion": "¡Hola! 👋"
    }
  }



// WEBPACK FOOTER //
// ./src/components/WhatsappSelect/dataContact.js